import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import createLogger from 'redux-logger';

import configure from './configure';
import Reducer from './reducer';
import {isPC, isIESupport, isAndroidSupport, isAndroidDefault, isIOSSupport, getUa} from './utils/device';

//Containers
import AppContainer from './containers/appcontainer';

if(!configure.IS_SSL && configure.ENV() !== "DEV"){
  location.href = 'https://'+location.host+location.pathname+location.hash;
}

const logger = createLogger();
let store;
if (process.env.NODE_ENV !== 'production') {
  store = createStore(Reducer,applyMiddleware(logger));
}else{
  store = createStore(Reducer);
}

const render = () =>{
  ReactDOM.render(
    <Provider store={store}>
      <AppContainer/>
    </Provider>,
    document.getElementById('app')
  );
}



//Android Default Browser
if(isAndroidSupport(configure.SUPPORT.ANDROID_MIN) && isAndroidDefault()){
  if(window.confirm(configure.MSG.USE_CHROME)){
    let url = "intent://"+location.host+location.pathname+"#Intent;scheme=http;package=com.android.chrome;end";
    location.href = url;
  }

//not Supported Browser
}else if(!isIOSSupport(configure.SUPPORT.IOS_MIN) && !isAndroidSupport(configure.SUPPORT.ANDROID_MIN) && !isIESupport(configure.SUPPORT.IE_MIN) && !isPC()){
  alert(configure.MSG.NOT_SUPPORT +" / "+ getUa().os +" / "+ getUa().version);

//Supported
}else{
  render();
}



// WEBPACK FOOTER //
// ./source/javascripts/index.js